// extracted by mini-css-extract-plugin
module.exports = {"WidgetWrapper":"WidgetWrapper--2L8Y1"};